import key from 'weak-key';
import { Col, Container, Row } from '@geberit/gdds';

// styles
import { TeaserTilesWrapper } from './teaser-tiles-wrapper.styles';

// types
import type { Content } from './teaser-tiles.types';

// constants
import { Formats } from 'components/ContentElementsGdds/headline/headlines.types';

// components
import { Headline } from 'components/ContentElementsGdds/headline/headline';
import TileLoader from './tile-loader';
import { Tiles } from '../CustomGdds/Tiles/src/tiles/tiles';

// utils
import { buildSize, gridSizes } from 'utils/gridSize';
import { useIsPreview } from 'utils/hooks/useIsPreview';
import { useSectionId } from 'utils/hooks/use-section-id';
import { isEmpty } from 'utils/is-empty';
import { useContent } from 'components/Page/page-hooks';

export function TeaserTiles({
  title,
  subtitle,
  tiles,
  text,
  anchor,
  titleInAnchor,
  contentIndex,
}: Readonly<Content>) {
  const content = useContent<{}, { heroTile: HeroTile }>();
  const hasHeroTile = !isEmpty(content?.page?.heroTile);
  const hasTextbox = title || subtitle || text;
  const sectionId = useSectionId(title, anchor, titleInAnchor, contentIndex);
  const isPreview = useIsPreview();

  return (
    <TeaserTilesWrapper hasHeroTile={hasHeroTile} id={sectionId}>
      {hasTextbox && (
        <div className="text-wrapper">
          <Container maxContentWidth={buildSize(gridSizes['gddsFullGrid'])}>
            <Row>
              <Col size={[4, 8, 12]} className="centered-col">
                {(title || subtitle) && (
                  <Headline
                    tag={Formats.h2}
                    title={title}
                    subtitle={subtitle}
                    text={text}
                    titlePreviewId="#st_title"
                    subtitlePreviewId="#st_subtitle"
                    textPreviewId="#st_text"
                    textClassName="copy-text"
                  />
                )}
              </Col>
            </Row>
          </Container>
        </div>
      )}
      <div>
        <Container maxContentWidth={buildSize(gridSizes['gddsFullGrid'])}>
          <Row>
            <Col size={[4, 8, 12]}>
              <Tiles previewId={isPreview ? '#st_teaserTiles' : undefined} type="expressive">
                {tiles.map((item, index) => (
                  <TileLoader tileIndex={index} key={key(item)} {...item} />
                ))}
              </Tiles>
            </Col>
          </Row>
        </Container>
      </div>
    </TeaserTilesWrapper>
  );
}
